import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=18828d9c&scoped=true&"
import script from "./UserEdit.vue?vue&type=script&lang=js&"
export * from "./UserEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18828d9c",
  null
  
)

export default component.exports